// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__EsvRw","dot":"offline-banner_dot__2pMFd","pulse":"offline-banner_pulse__5iZMM"};